import * as React from 'react';
import { Chip, ChipProps, darken } from '@mui/material';
import { PreferenceDisplay, DEFAULT_PREFERENCE_COLOR } from '../../types/Preference';
import { expandShortHex, getContrastingText } from '../../utility/preferenceColor';

type Props = Omit<ChipProps, 'label' | 'color'> & PreferenceDisplay;

export default function PreferencePill({ value, color, size = 'small', ...otherProps }: Props) {
  if (!value) return null;

  const bg = expandShortHex(color || undefined) ?? DEFAULT_PREFERENCE_COLOR;
  const fg = getContrastingText(bg);
  const border = darken(bg, 0.2);

  return (
    <Chip
      {...otherProps}
      size={size}
      label={value}
      sx={{
        ...otherProps.sx,
        bgcolor: bg,
        color: fg,
        border: `1px solid ${border}`,
        '& .MuiChip-label': { px: 1, fontWeight: 500 },
      }}
    />
  );
}
